import React from "react";
import { useTicketRoutes } from "hooks";
import { NavigationPageItems } from "components";

export const TicketsNavigationPage: React.FC = () => {
  const { TicketNavigationRoot } = useTicketRoutes();
  return <NavigationPageItems navigationRoot={TicketNavigationRoot} />;
};
